import React, { useEffect } from "react";
import { Modal, Box, Typography, Button, Grid, Tooltip } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useNavigate } from "react-router-dom";
import { setEngagedCouple } from "../../../redux/slices/RequestFormSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const PostAdModal = ({ open, toggle }) => {
  const formData = useSelector((state) => state.requestForm);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const islogin = useSelector((state) => state.user.isLogin);
  const adTypes = [
    {
      id: 1,
      title: "You have a community Need",
      color: "#ff4d4d",
      link: "/needs-requests/request",
      tab: "normal-need",
      description:
        "Matrimony, Real Estate, Job, Business",
    },
    {
      id: 2,
      title: "You have an upcoming Event or Wedding",
      color: "#4d79ff",
      link: "/needs-requests/request",
      engagedCouple: true,
      tab: "upcoming-event",
      description:
        "If you have an event coming up & need a service. Vendors will call you",
    },
    {
      id: 3,
      title: "You have a service to sell",
      color: "#4db84d",
      link: "/create-service",
      tab: "service-sell",
      service: true,
      description:
        "This is for Event Vendors to list their service. We will send customers to you",
    },
    {
      id: 4,
      title: "You have an Item to Sell",
      color: "#ffba08",
      link: "/create-item",
      tab: "item-sell",
      item: true,
      description:
        "This is like Craigslist. It will list your item for sale & people can visit you to pickup item",
    },
  ];

  const handleSelect = (ad) => {
    if (!islogin && ad.service) {
      toast.error("Please login to create a service");
      return;
    }
    if (ad.engagedCouple) {
      dispatch(setEngagedCouple(1));
    } else {
      dispatch(setEngagedCouple(0));
    }
    navigate(`${ad.link}?tab=${ad.tab}`);
    toggle();
  };

  return (
    <Modal open={open} onClose={toggle}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "80%",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h4" textAlign="center" mb={3}>
          Post Your Ad
        </Typography>
        <Grid container spacing={3} justifyContent="center">
          {adTypes.map((ad, index) => (
            <Grid item xs={12} sm={6} md={3} key={ad.id}>
              <Box
                sx={{
                  border: `2px solid ${ad.color}`,
                  borderRadius: "100px 0px",
                  overflow: "hidden",
                  bgcolor: "white",
                  height: "100%",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.5)",
                }}
              >
                <Box
                  sx={{
                    color: `${ad.color}`,
                    p: 2,
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{ fontSize: "15px", paddingTop: "28px" }}
                  >
                    {ad.title}
                  </Typography>
                  <Tooltip title={ad.description} arrow>
                    <HelpOutlineIcon
                      sx={{
                        fontSize: "18px",
                        ml: 1,
                        cursor: "pointer",
                        color: `${ad.color}`,
                        "&:hover": {
                          opacity: 0.8,
                        },
                      }}
                      aria-label={`More information about ${ad.title}`}
                    />
                  </Tooltip>
                </Box>
                <Box textAlign="center" sx={{ pb: 3 }}>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: ad.color,
                      color: "white",
                      borderRadius: "8px",
                      padding: "5px 15px",
                      "&:hover": {
                        backgroundColor: `${ad.color}CC`,
                      },
                    }}
                    onClick={() => handleSelect(ad)}
                  >
                    Select
                  </Button>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Modal>
  );
};

export default PostAdModal;
